import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_ADVOCATE_ENTRY_POINT = defineFcm('advocate_entry_point')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				buttonLabel: { type: 'string' },
				disabledCps: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		buttonLabel: '',
		disabledCps: [],
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context: 'Advocate Entry Point',
		description:
			'Enables the Advocate Entry Point on the PSF Promote or Share page. Allows to set a custom button label for the Advocate Entry Point. Additionally, it allows to disable the Advocate Entry Point for specific CPs.',
		import: false,
		template: {
			enabled: false,
			buttonLabel: '',
			disabledCps: [],
		},
	});
